export class SortingModel {
    sortColumn: string | undefined;
    sortDirection: string | undefined;
}
